var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectsLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23,5.5H14.51a1,1,0,0,1-.77-.36L11.42,2.36A1,1,0,0,0,10.66,2H5A1,1,0,0,0,4,3V5.5H8.09a1,1,0,0,1,.79.39l2.32,3a1,1,0,0,0,.79.39h7.73a1,1,0,0,1,1,1V18H23a1,1,0,0,0,1-1V6.5A1,1,0,0,0,23,5.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M18.29,10.83H11a1,1,0,0,1-.8-.39l-2.32-3A1,1,0,0,0,7.09,7H1A1,1,0,0,0,0,8V21a1,1,0,0,0,1,1H18.29a1,1,0,0,0,1-1V11.83A1,1,0,0,0,18.29,10.83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsLight);
export default __webpack_public_path__ + "static/media/projects-light.0494b4a783b1ab1464a85868cb0a989e.svg";
export { ForwardRef as ReactComponent };